import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import moment from "moment";

import Lightbox from "react-image-lightbox";

//import filter modal
import FilterModal from "../../components/Modal/FilterModal.js";

import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequest,
  putRequestForm,
  postRequestForm,
} from "../../components/Common/Utils.js";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import BuyProduct from "components/Modal/BuyProduct.js";

const filterObj = {
  venueName: "",
  userName: "",
  title: "",
  stars: "",
  review: "",
  reply: "",
  status: "",
  createdAt: "",
};

const WareHouseProductesTable = ({ userId }) => {
  const [modal_center, setmodal_center] = useState(false);
  const [Productdata, setProductdata] = useState([]);
  const [buyProductdata, setBuyProductdata] = useState({});
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [value, setValue] = React.useState(10);
  const [stockModal, setStockkshow] = useState(false);
  const [stockData, setStockAlret] = useState({});
  const [blockData, setBlockData] = useState({});
  const [stockDataValue, setStockAlertValue] = useState(0);
  const [blockValue, setBlockValue] = useState('');

  const [sort, setsort] = React.useState("createdAt");
  const [sortOrder, setsortOrder] = React.useState("desc");

  useEffect(() => {
    setStockAlertValue(stockData?.stockAlert || 0);
  }, [stockData]);

  useEffect(() => {
    setBlockValue(blockData?.block || '');
  }, [blockData]);

  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [image, setImage] = React.useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [blockModal, setBlockshow] = React.useState(false);
  const [model, setModel] = useState(false);
  const [filter, setFilter] = useState({ ...filterObj });

  const [loader2, setLoader2] = useState(false);

  const GetValueOnChange = async (value, _id) => {
    let actId = _id;
    let status = value == 1 ? 1 : 0;

    const formData = new FormData();
    formData.append("ProductId", actId);
    formData.append("isPublished", status);

    const res = await postRequest("update-by-admin", formData);

    if (res.status) {
      toast.success("Product Status updated Successfully");
      ProductManagment();
    } else {
      toast.error("Something went wrong");
      setLoader(false);
    }
  };

  useEffect(() => {
    ProductManagment();
  }, [currentPage]);

  useEffect(() => {
    ProductManagment();
  }, [sizePerPageOrg, sort, sortOrder]);

  const closeModal = () => {
    setModel(false);
  };

  const toggleModel = (row) => {
    console.log("toggleModel", model);
    setModel(!model);
    const dataFilter = {
      name: row?.productDetail?.name,
      images: row?.productDetail?.images,
      _id: row?.productDetail?._id,
      minimumQuantity: row?.productDetail?.priceRange?.[0]?.minQuantity,
      manufacturerDetail: row?.manufacturerDetail,
    }
    setBuyProductdata(dataFilter);
  };

  const handleUpdateStockAlert = async (_id) => {
    // setLoader(true);
    if (stockDataValue <= 0) {
      toast.warn('Stock alert value must be a positive number and at least 1.');
      return false;
    }
    try {
      const response = await postRequest(`warehouse/update-inventory`, {
        inventoryId: _id,
        stockAlert: stockDataValue
      });
      if (response?.status) {
        Swal.fire({
          title: 'Success!',
          text: response?.message,
          icon: 'success',
          confirmButtonText: 'Okay'
        });
        setStockkshow(false);
        ProductManagment();
      }
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleUpdateBlock = async (_id) => {
    // setLoader(true);
    if (!blockValue) {
      toast.warn('Please enter block');
      return false;
    }
    try {
      const response = await postRequest(`warehouse/update-inventory`, {
        inventoryId: _id,
        block: blockValue
      });
      if (response?.status) {
        Swal.fire({
          title: 'Success!',
          text: response?.message,
          icon: 'success',
          confirmButtonText: 'Okay'
        });
        setBlockshow(false);
        ProductManagment();
      }
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };



  const selectRow = (item) => {
    console.log({ item })
    // setAssingDeliveryData({
    //   Image: item?.image,
    //   Title: item?.title,
    //   categoryId: item?._id,
    //   show: true
    // });
    // deliveryAssingOrder(item?._id);
    setModel(false);
  };


  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    console.log("type", type);

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  const updateFilter = (key, value) => {
    const filterObj = { ...filter };
    filterObj[key] = value;
    setFilter(filterObj);
  };

  const applyFilter = () => {
    const filterArgs = [];

    Object.keys(filter).forEach((key) => {
      if (
        filter[key] !== "" &&
        filter[key] !== null &&
        filter[key] !== undefined
      ) {


        var filterObject = {
          [key]: filter[key],
        };


        if (key === "venueName" || key === "userName" || key === "review" || key === "reply") {
          filterObject.type = "regex";
        } else if (key === "status" || key === "stars") {
          filterObject.type = "eq";
        } else if (key === "createdAt") {
          filterObject.type = "date-eq";
        }

        filterArgs.push(filterObject);
      }
    });

    console.log("filterArgs", filterArgs);
    toggleModel();
    ProductManagment(filterArgs);
  };

  const resetFilter = () => {
    setFilter({ ...filterObj });
    toggleModel();
    ProductManagment();
  };

  const defaultSorted = [
    {
      dataField: "_id",
      order: "asc",
    },
  ];

  function tog_center() {
    setmodal_center(!modal_center);
    removeBodyCss();
  }

  function activeFormatter(cellContent, row) {
    return (
      <>
       <div className="d-flex gap-2 align-items-center">
        <h5 class="mb-0"> {row?.block}</h5>
        <button type="button" onClick={() => blocktoggleModel(row)} className="btn btn-primary" style={{ padding: '2px 7px' }}>
          <i className="fal fa-edit" />
        </button>
      </div>
      
        {/* {row?.block?.map((item, index) => (
          <div key={index}>
            {Object.keys(item).map((key, i) => (
              <p className="mb-0" key={i}>
                {key}: {item[key]}{i < Object.keys(item).length - 1 ? ', ' : ''}
              </p>
            ))}
          </div>
        ))} */}
      </>
    );
  }


  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };


  const handleDownload = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = image;
    downloadLink.download = "downloaded-image.jpg";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  function ProductNameFormatter(cellContent, row) {
    return (
      <React.Fragment>
        <div>
          {row?.productDetail?.name}
        </div>
      </React.Fragment>
    );
  }


  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }



  function ProductFormatter(cellContent, row) {
    return (
      <>
        <img
          src={row?.productDetail?.images?.[0]}
          onClick={() => showLightBox(row?.productDetail?.images?.[0])}
          alt="Not found Product"
          width={"50px"}
        />
      </>
    );
  }

  const CMtoggleModel = (item) => {
    setStockkshow(true);
    setStockAlret(item);
  };

  const blocktoggleModel = (item) => {
    setBlockshow(true);
    setBlockData(item);
  };

  function stockAlertfunction(cellContent, row) {
    return (
      <div className="d-flex gap-2 justify-content-center text-center align-items-center">
        <h5 className="mb-0">{row?.stockAlert.toLocaleString()}</h5>
        <button type="button" onClick={() => CMtoggleModel(row)} className="btn btn-primary" style={{ padding: '2px 7px' }}>
          <i className="fal fa-edit" />
        </button>
      </div>
    );
  }

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },

    {
      dataField: "images[]",
      text: "Product image",
      sort: false,
      formatter: ProductFormatter,
    },

    {
      dataField: "name",
      text: "Product Name",
      sort: false,
      formatter: ProductNameFormatter,
    },
    {
      dataField: "quantity",
      text: "Quantity",
      sort: false,
    },
    {
      dataField: "remainingQuantity",
      text: "Remaining Quantity",
      sort: false,
    },
    {
      formatter: stockAlertfunction,
      text: "Stock Alert Quantity",
      sort: false,
    },

    {
      text: "Block",
      sort: false,
      formatter: activeFormatter,
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: iconFormatter,
      sort: false,
    },
  ];

  function userFormatter(cellContent, row) {
    return (
      <div style={{ display: 'flex', gap: '10px' }}>
        <img
          src={row.userImage}
          onClick={() => showLightBox(row.userImage)}
          alt="Image"
          width={"50px"}
          style={{ borderRadius: '20%' }} // This makes the image round
        />
        <p>{row.userName}</p>
      </div>
    );
  }

  function hotelFormatter(cellContent, row) {
    return (
      <div style={{ display: 'flex', gap: '10px' }}>
        {/* <img
        src={row?.type == 'hotel' ?  row?.hotelData?.image[1]?.fileName : row?.type == 'transfer' ? row?.transferData?.image[1]?.fileName : row?.type == 'ticket' ? `https://ui-avatars.com/api/?background=random&name=${row?.ticketData?.name}` : '' }
        onClick={() => showLightBox(row?.type == 'hotel' ?  row?.hotelData?.image[0]?.fileName : row?.type == 'transfer' ? row?.transferData?.image[0]?.fileName : row?.type == 'ticket' ? `https://ui-avatars.com/api/?background=random&name=${row?.ticketData?.name}` : '')}
        alt="Image"
        width={"50px"}
        style={{ borderRadius: '20%' }} // This makes the image round
      /> */}
        <p>{row?.type == 'hotel' ? row?.hotelData?.name : row?.type == 'ticket' ? row?.ticketData?.name : row?.transferData?.name}</p>
      </div>
    );
  }

  const handleChange = (event) => {
    setSizePerPage(event.target.value);
  };
  const handlesorting = (event) => {
    setsort(event.target.value);
  };
  const handlesortOrder = (event) => {
    setsortOrder(event.target.value);
  };
  const handleReload = () => {
    setSearchText(" ");
    ProductManagment();
  };

  function iconFormatter(cellContent, row) {
    return (
      <React.Fragment>
        <div className="d-flex">
          <button type="button" className=" btn btn-info  mx-2">
            {" "}
            <Link
              to={{
                pathname: `/product-details/${row?.productDetail?._id}`,
              }}
            >
              {" "}
              <i class="fal fa-eye text-light"></i>
            </Link>{" "}
          </button>
          {/* <button type="button" class="btn btn-info" onClick={() => toggleModel(row)}>
            <i className="fal fa-shopping-cart"></i>&nbsp;
            Buy Product</button> */}

        </div>
      </React.Fragment>
    );
  }



  const ProductManagment = async (filterArgs = []) => {
    try {
      setLoader(true);
      // Construct payload
      const payload = {
        limit: sizePerPageOrg,
        page: currentPage,
        sortField: sort,
        sortOrder: sortOrder,
        // userId: userId,
        search: searchText,
      };

      // Handle filter arguments or search text
      if (filterArgs?.length) {
        payload.filterArgs = filterArgs;
      } else if (searchText) {
        payload.search = searchText;
      }

      // Make API request
      const response = await postRequest('warehouse/list-inventory', payload);

      // Handle response data
      const data = response?.data || [];
      setTotalPage(data.count);
      setProductdata(data?.list);

      // Reset search text
      setSearchText('');
    } catch (error) {
      console.error('Error fetching product list:', error);
      // Optionally display error feedback to the user
    } finally {
      setLoader(false);
    }
  };


  const handlerdelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`Product/update`, { ProductId: id });
        if (response.status) {
          Swal.fire("Deleted!", "Deleted successfully");
          ProductManagment();
        } else {
          Swal.fire("Error!", "Something went wrong");
        }
      }
    });
  };


  return (
    <>
      <React.Fragment>
        <ToastContainer />
        <Row>
          {/* <Col className="12">
            <div className="page-title-box">
              <h4>Hotel Product Management</h4>

              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item active">Product Management</li>:{" "}
                <li className="breadcrumb-item">Product List</li>
              </ol>
            </div>
          </Col> */}

          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={Productdata}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <label className="mb-0 text-label">
                                    Page Size
                                  </label>
                                  <select
                                    value={sizePerPageOrg}
                                    onChange={handleChange}
                                    className="form-select"
                                    style={{ width: "7%" }}
                                  >
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                  </select>

                                  {/* <label className="mb-0 text-label ms-3">
                                    Sort By:
                                  </label>
                                  <select
                                    value={sort}
                                    onChange={handlesorting}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="Name">
                                      {" "}
                                      Product Name
                                    </option>
                             
                        
                                    <option value="description">Description</option>
                                    <option value="unit">Unit</option>
                                    <option value="status">status</option>
                                 
                                  </select> */}
                                  <label className="mb-0 text-label ms-3">
                                    Sort Order:
                                  </label>
                                  <select
                                    value={sortOrder}
                                    onChange={handlesortOrder}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="asc"> Ascending</option>
                                    <option value="desc">Descending</option>

                                  </select>
                                  <div className="filter-item">
                                    <input
                                      type="search"
                                      placeholder="Search"
                                      value={searchText}
                                      class="form-control"
                                      onChange={(e) =>
                                        setSearchText(e.target.value)
                                      }
                                      style={{ width: "30%" }}
                                    />
                                    <button
                                      onClick={() => {
                                        ProductManagment();
                                      }}
                                      type="button"
                                      className="btn btn-primary mx-2"
                                    >
                                      Search
                                    </button>
                                    <button
                                      type="button"
                                      onClick={handleReload}
                                      className="btn btn-danger mx-2"
                                    >
                                      Reset
                                    </button>

                                    {/* <button
                                      type="button"
                                      onClick={toggleModel}
                                      className="btn btn-info"
                                    >
                                      Filter
                                    </button> */}
                                  </div>
                                </Col>

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>

        {openLightbox && (
          <>
            <Lightbox
              mainSrc={image}
              onCloseRequest={() => setOpenLightBox(false)}
              toolbarButtons={[
                <button
                  className="btn btn-primary"
                  key="download"
                  onClick={handleDownload}
                >
                  Download
                </button>,
              ]}
            />
          </>
        )}

        <Modal
          isOpen={stockModal}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered={true}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myLargeModalLabel">
              Stock Alert Quantity
            </h5>
            <button
              onClick={() => setStockkshow(false)}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="product-item">
              <div className="image-product">
                <img src={stockData?.productDetail?.images?.[0]} alt={stockData?.productDetail?.images?.[0]} />
              </div>
              <div className="product-info" style={{ width: '50%' }}>
                <h5>{stockData?.productDetail?.name}</h5>
                <div className="manufacturedetail">
                  <div className="logo-manufacturedetail"> <img src={stockData?.manufacturerDetail?.logo} /></div>
                  {stockData?.manufacturerDetail?.companyName} <br />
                  {stockData?.manufacturerDetail?.address}
                </div>
                <label className="mb-0">Stock Alert Quantity</label>
                <div className="cart_qty mb-2 mt-0">
                  <div className="input-group quantity-prod">
                    <input
                      className="form-control input-number qty-input"
                      type="number"
                      onChange={(e) => setStockAlertValue(e.target.value ? Number(e.target.value) : 0)}
                      value={stockDataValue}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger" onClick={() => setStockkshow(false)}>
              Cancel
            </button>
            <button type="button" className="btn btn-info" onClick={() => handleUpdateStockAlert(stockData?._id)}>
              Save
            </button>
          </div>

        </Modal>

        <Modal
          isOpen={blockModal}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered={true}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myLargeModalLabel">
              Update Block
            </h5>
            <button
              onClick={() => setBlockshow(false)}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="product-item">
              <div className="image-product">
                <img src={blockData?.productDetail?.images?.[0]} alt={blockData?.productDetail?.images?.[0]} />
              </div>
              <div className="product-info" style={{ width: '50%' }}>
                <h5>{blockData?.productDetail?.name}</h5>
                <div className="manufacturedetail">
                  <div className="logo-manufacturedetail"> <img src={blockData?.manufacturerDetail?.logo} /></div>
                  {blockData?.manufacturerDetail?.companyName} <br />
                  {blockData?.manufacturerDetail?.address}
                </div>
                <label className="mb-0">Update Block</label>
                <div className="cart_qty mb-2 mt-0" style={{width:' 100%'}}>
                  <div className="input-group quantity-prod">
                    <input
                      className="form-control input-number qty-input"
                      type="text"
                      onChange={(e) => setBlockValue(e.target.value ? String(e.target.value) : '')}
                      value={blockValue}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger" onClick={() => setBlockshow(false)}>
              Cancel
            </button>
            <button type="button" className="btn btn-info" onClick={() => handleUpdateBlock(blockData?._id)}>
              Save
            </button>
          </div>

        </Modal>

        <BuyProduct
          show={model}
          data={buyProductdata}
          closeModal={closeModal}
          selectRow={selectRow} />

      </React.Fragment>
      {/* <FilterModal
        show={model}
        closeModal={closeModal}
        components={components}
      /> */}
    </>
  );
};

export default WareHouseProductesTable;
